import React, { useState, useEffect } from "react";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import {
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import SwalMessage from "../../_Components/SwalMessage";
import ApiPaymentService from "../../../../core/api/api.paymentService";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SelectComponent from "../../_Components/ReactSelectComponent";

const ModalPortal = ({ showModalPortal, setShowModalPortal, selectedPortalId }) => {
  // let navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      id: 0,
    },
  });
  const [enumData, setenumData] = useState({});
  const handleClose = () => {
    setShowModalPortal(false);
  };

  // let back = (e) => {
  //   e.stopPropagation();
  //   navigate(-1);
  // };

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPaymentService.getEnumType();
        setenumData(data.data);

        if (selectedPortalId != 0) {
          let selectedTypeById = await ApiPaymentService.get(selectedPortalId);
          if (selectedTypeById.succeeded) {
            //setListData(selectedTypeById.data);
            setValue("id", selectedTypeById.data.id);
            setValue("title", selectedTypeById.data.title);
            setValue("status", selectedTypeById.data.status);
            setValue("titleShow", selectedTypeById.data.titleShow);
            setValue("indexView", selectedTypeById.data.indexView);
            setValue("type", data.data.type.map((item) => ({
              value: item.id,
              label: item.title,
            })).find(d => d.value == selectedTypeById.data.type));
            setValue("group", data.data.group.map((item) => ({
              value: item.id,
              label: item.title,
            })).find(d => d.value == selectedTypeById.data.group));
            setValue("accountId", data.data.accountList.map((item) => ({
              value: item.id,
              label: `آیدی: ` +
                item.id +
                `شماره کارت:` +
                item.cardNumber +
                `- شماره حساب :` +
                item.accountNumber +
                `به نام:` +
                item.accountOwnerName +
                ` ` +
                item.cardOwnerName,
            })).find(d => d.value == selectedTypeById.data.accountId));
            setValue("imageUrl", selectedTypeById.data.imageUrl == null ? "آدرسی ذخیره نشده است" : "");
            setValue("description", selectedTypeById.data.description);
            //setValue("lastOrderId", selectedTypeById.data.lastOrderId);
            setValue("lastOrderId", undefined);
            setValue("site", selectedTypeById.data.site);
            setValue("terminalId", selectedTypeById.data.terminalId);
            setValue("userName", selectedTypeById.data.userName);
            setValue("userPassword", selectedTypeById.data.userPassword);

            setValue("sha1Key", selectedTypeById.data.sha1Key);
          }
        }
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    if (data.type) data.type = data.type.value
    if (data.group) data.group = data.group.value
    if (data.accountId) data.accountId = data.accountId.value

    try {
      let result = {};
      if (data.id != 0) result = await ApiPaymentService.updatePaymentPortalType(data);
      else result = await ApiPaymentService.createPaymentPortalType(data);
      document.getElementById("submitButton").click()
      handleClose()
      SwalMessage({ title: result.message, iSsuccess: result.succeeded });
    } catch (error) {
      SwalMessage({ title: "در درخواست شما مشکلی پیش آمد مجدد امتحان کنید", iSsuccess: false });
    }
  };

  return (
    <div>
      <Modal centered size="md" onHide={handleClose} show={showModalPortal}>
        <form id="form2" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> {selectedPortalId != 0 ? "ویرایش درگاه " : "افزودن درگاه جدید"} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <FormControlLabel
                  control={
                    <Controller
                      name="status"
                      control={control}
                      render={({ field: { onChange, onBlur, value = false, name, ref } }) => (
                        <Checkbox onBlur={onBlur} onChange={onChange} checked={value} inputRef={ref} color="primary" />
                      )}
                    />
                  }
                  label="وضعیت نمایش"
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="title"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="عنوان درگاه"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {errors.title && <span className="text-danger">لطفا عنوان درگاه را وارد نمایید</span>}
              </Col>
              <Col xs="12">
                <Controller
                  name="titleShow"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="عنوان نمایشی به کاربر"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {
                  errors.titleShow && (<span className="text-danger">لطفا عنوان نمایشی به کاربر را وارد نمایید</span>)
                }
              </Col>

              <Col xs="12">
                <Controller
                  name="indexView"
                  control={control}
                  //rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="ترتیب نمایش درگاه ها به کاربر"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={_.toInteger(value) || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {/* {errors.indexView && (<span>لطفا ترتیب نمایش درگاه به کاربر را وارد نمایید</span>)} */}
              </Col>
              <Col xs="12" className="mt-1">
                <Controller
                  name="type"
                  control={control}
                  render={({ field }) => (
                    <SelectComponent
                      options={enumData?.type?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      placeholder="نوع درگاه"
                      className="w-100 mt-5"
                      variant="outlined"
                      size="small"
                      field={field}
                    />
                  )}
                />

                {
                  // errors.type && (<span>لطفا نوع پرتال را انتخاب نمایید</span>)
                }
              </Col>

              <Col xs="12" className="mt-2">
                <Controller
                  name="group"
                  control={control}
                  render={({ field }) => (
                    <SelectComponent
                      options={enumData?.group?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      placeholder="نوع گروه"
                      className="w-100 mt-5"
                      variant="outlined"
                      size="small"
                      field={field}
                    />
                  )}
                />

                {
                  // errors.group && (<span>لطفا نوع گروه را انتخاب نمایید</span>)
                }
              </Col>
              <Col xs="12" className="mt-2">
                <Controller
                  name="imageUrl"
                  control={control}
                  //rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="آدرس آیکن درگاه"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {
                  // errors.imageUrl && (<span>لطفا آدرس ایکن پرتال را وارد نمایید</span>)
                }
              </Col>

              <Col xs="12">
                <Controller
                  name="description"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="توضیحات"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
              </Col>

              <Col xs="12">
                <Controller
                  name="accountId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      options={enumData?.accountList?.map((item) => ({
                        value: item.id,
                        label: `آیدی: ` +
                          item.id +
                          `شماره کارت:` +
                          item.cardNumber +
                          `- شماره حساب :` +
                          item.accountNumber +
                          `به نام:` +
                          item.accountOwnerName +
                          ` ` +
                          item.cardOwnerName,
                      }))}
                      placeholder="مشخصات حساب ها"
                      className="w-100 mt-5"
                      variant="outlined"
                      size="small"
                      field={field}
                    />
                  )}
                />
                {errors.accountId && <span className="text-danger">لطفا حساب مرتبط با این درگاه را انتخاب نمایید</span>}
              </Col>
              <Col xs="12" className="mt-1">
                <Controller
                  name="lastOrderId"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="lastOrderId"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      placeholder="در صورت خالی بودن به روز رسانی نمی شود"
                    />
                  )}
                />
              </Col>
            </Row>
            {
              <Row>
                {/* moshakhasat bank melat */}
                <Col xs="12">
                  <Controller
                    name="site"
                    control={control}
                    //rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="site"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={_.isEmpty(value) == false ? value : ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {/* {errors.site && <span>لطفا site را وارد نمایید</span>} */}
                </Col>
                <Col xs="12">
                  <Controller
                    name="terminalId"
                    control={control}
                    //rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="terminalId"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={_.isEmpty(value) == false ? value : ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {/* {errors.terminalId && (<span>لطفا ترمینال ایدی را وارد نمایید</span>)} */}
                </Col>
                <Col xs="12">
                  <Controller
                    name="userName"
                    control={control}
                    //rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="userName"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={_.isEmpty(value) == false ? value : ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {/* {errors.userName && (<span>لطفا نام کاربری را وارد نمایید</span>)} */}
                </Col>
                <Col xs="12">
                  <Controller
                    name="userPassword"
                    control={control}
                    //rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="userPassword"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={_.isEmpty(value) == false ? value : ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {/* {errors.userPassword && (<span>لطفا پسورد را وارد نمایید</span>)} */}
                </Col>
              </Row>
            }
            {
              <Row>
                {/* moshakhasat bank kish */}
                <Col xs="12">
                  <Controller
                    name="sha1Key"
                    control={control}
                    //rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="sha1Key"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={_.isEmpty(value) == false ? value : ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {/* {errors.sha1Key && <span>لطفا sha1Key را وارد نمایید</span>} */}
                </Col>
              </Row>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default ModalPortal;
